import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar, EventSourceApi } from '@fullcalendar/core';
import { CalendarOpts } from "./calendar";

export function initCalGroups(cal: Calendar, opts: CalendarOpts) {
  p('initCalGroups');

  const calendar = cal;
  Cookies.set('teaching_group_back', window.location.href, { path: '/' });
  Cookies.set('parish_back', window.location.href, { path: '/' });
  Cookies.set('teaching_place_back', window.location.href, { path: '/' });
  Cookies.set('user_back', window.location.href, { path: '/' });
  Cookies.set('visitation_report_back', window.location.href, { path: '/' });

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default margin-left-5px margin-bottom-5px toggle-calendar-groups',
    html: '<i class="fa fa-clock-o"></i> Órarend'
  });
  $('#btnContainer').append(btn);

  let source: EventSourceApi | null = null;
  let active = !(Cookies.get('cal_no_groups') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.addClass('active') : btn.removeClass('active');
    Cookies.set('cal_no_groups', (!active) + '', {
      expires: 10,
      path: '/'
    });
    if (source) {
      active ? calendar.addEventSource(source) : source.remove();
    } else if (active) {
      source = calendar.addEventSource({
        url: '/teaching_groups/times.json',
        startEditable: true,
        extraParams: {
          'q[teacher_user_id_eq]': opts.user_id
        }
      });
    }
  }

}